import * as z from 'zod';

const sxValueSchema: z.ZodTypeAny = z.lazy(() =>
  z.union([z.string(), z.number(), z.record(z.string(), sxValueSchema)]),
);

export const sxSchema = z.record(z.string(), sxValueSchema).optional();

export type ValidatedSx = z.infer<typeof sxSchema>;

export const parseSxConfig = (rawJsonOrString: unknown): ValidatedSx => {
  let rawJson = rawJsonOrString;
  if (typeof rawJsonOrString === 'string') {
    try {
      rawJson = JSON.parse(rawJsonOrString);
    } catch (e) {
      rawJson = undefined;
    }
  }
  const result = sxSchema.safeParse(rawJson);

  if (!result.success) {
    console.error('Invalid sx configuration from Payload:', result.error);
    return {};
  }

  return result.data || undefined;
};
